import {FC} from "react";
import '../styles/Chip.scss';


interface ChipProps {
    chip: string
}

export const Chip: FC<ChipProps> = ({chip}) => {
    return <>
        <span className="chip">{chip}</span>
    </>
}